import { createFileRoute } from '@tanstack/react-router';
import { MyInterestsPage } from '@/pages/staffing/MyInterestsPage';

export const Route = createFileRoute('/_authenticated/_app/staffing/my-interests')({
	component: MyInterestsPage,
});
